var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalRoot',{attrs:{"name":_vm.MODAL_KEYS.DEBUGGER_INSPECT}},[_c('DebuggerInspectModal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }